import { EpDevPApiFactories } from "../EpDevPApiFactories";

const SUPPORT_PATH = "support";
const ABOUT_PATH = "about";
const SYSTEM_TICKET_PATH = "tickets/system";
const USER_TICKET_PATH = "tickets/user";

export class EpDevPSupportApiRoutesFactory extends EpDevPApiFactories {

  public static subRouteBase = (): string => {
    return `/${SUPPORT_PATH}`;
  }
  public static subRouteSystemTicket = (): string => {
    return `${EpDevPSupportApiRoutesFactory.subRouteBase()}/${SYSTEM_TICKET_PATH}`;
  }
  public static postSubRouteSystemTicket = (): string => { 
    return EpDevPSupportApiRoutesFactory.subRouteSystemTicket();
  }
  public static subRouteUserTicket = (): string => {
    return `${EpDevPSupportApiRoutesFactory.subRouteBase()}/${USER_TICKET_PATH}`;
  }
  public static postSubRouteUserTicket = (): string => { 
    return EpDevPSupportApiRoutesFactory.subRouteUserTicket();
  }
  public static getSubRouteAbout = (): string => { 
    return `${EpDevPSupportApiRoutesFactory.subRouteBase()}/${ABOUT_PATH}`;
  }
}

export class EpDevPSupportApiPathsFactory {

  public static createSystemTicketPath(): string {
    return `/${SUPPORT_PATH}/${SYSTEM_TICKET_PATH}`;
  }

  public static createUserTicketPath(): string {
    return `/${SUPPORT_PATH}/${USER_TICKET_PATH}`;
  }

  public static createAboutPath(): string {
    return `/${SUPPORT_PATH}/${ABOUT_PATH}`;
  }
}
